import { createSelector } from 'reselect'
import DrawingIdSelector from './drawing_id_selector'

const getWhiteboardData = state => state.whiteboardSession

const getActionsData = createSelector(
	[ getWhiteboardData, DrawingIdSelector ],
	(whiteboard, id) => ({
		actions: whiteboard.actions.teacher,
		id,
	})
)

export default getActionsData
